import React, { useState, useEffect } from 'react';
import { 
  Typography, 
  Paper, 
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Alert,
  CircularProgress,
  Box,
  Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchDocuments } from '../utils/api';

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    const loadDocuments = async () => {
      try {
        setLoading(true);
        const response = await fetchDocuments();
        setDocuments(response.data);
        setError(null);
      } catch (err) {
        console.error('Failed to load documents:', err);
        setError('Failed to load documents. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    
    loadDocuments();
  }, []);
  
  const handleViewSegments = (documentId) => {
    navigate(`/segments/${documentId}`);
  };
  
  const handleCompleteReview = (documentId) => {
    navigate(`/complete-review/${documentId}`);
  };
  
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Source Documents
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {documents.length === 0 && !loading && !error ? (
        <Alert severity="info">
          No documents found in the database. Ingest some documents to get started.
        </Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Path</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {documents.map((doc) => (
                <TableRow key={doc.id}>
                  <TableCell>{doc.id}</TableCell>
                  <TableCell>{doc.name}</TableCell>
                  <TableCell>{doc.file_path}</TableCell>
                  <TableCell>
                    {doc.is_segmented ? (
                      <Chip label="Segmented" color="success" size="small" />
                    ) : (
                      <Chip label="Not Segmented" color="warning" size="small" />
                    )}
                  </TableCell>
                  <TableCell>
                    {new Date(doc.created_at).toLocaleString()}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={() => handleViewSegments(doc.id)}
                      >
                        View Segments
                      </Button>
                      {doc.is_segmented && (
                        <Button 
                          variant="contained" 
                          size="small"
                          color="primary"
                          onClick={() => handleCompleteReview(doc.id)}
                        >
                          Complete Review
                        </Button>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default Documents; 